import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { tooltipStyle } from "./oversiktConstants";
import { num } from "@/lib/formatters";

const MEASURES = [
  ["utpendling_pct", "Pendlar ut (% av sysselsette busette)"],
  ["innpendling_pct", "Pendlar inn (% av arbeidsplassane)"],
  ["arbeidsplassdekning_pct", "Arbeidsplassdekning (%)"],
];

export const PendlingAvgChart = ({ kommune, averages, fylkeName, gruppeNamn }) => {
  if (!averages?.land) return null;
  const snittKey = gruppeNamn ? "Snitt for storbyane" : `Fylkessnitt (${fylkeName || "fylket"})`;
  const data = MEASURES.map(([key, label]) => ({
    name: label,
    Kommunen: kommune[key],
    ...(averages.fylke ? { [snittKey]: averages.fylke[key] } : {}),
    Landssnitt: averages.land[key],
  }));
  return (
    <div data-testid="pendling-avg-chart">
      <p className="text-xs font-semibold uppercase tracking-[0.1em] text-[#8AA4BF] mb-2">Kommunen mot {averages.fylke ? (gruppeNamn ? "storby- og landssnittet" : "fylkes- og landssnittet") : "landssnittet"}</p>
      <div className="h-[260px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barCategoryGap="30%">
            <CartesianGrid strokeDasharray="3 3" stroke="#E6E9F0" />
            <XAxis dataKey="name" stroke="#8AA4BF" fontSize={11} interval={0} />
            <YAxis stroke="#8AA4BF" fontSize={12} tickFormatter={(v) => `${num(v)} %`} />
            <Tooltip formatter={(v) => `${num(v)} %`} contentStyle={tooltipStyle} />
            <Legend itemSorter={null} />
            <Bar dataKey="Kommunen" fill="#103766" radius={[4, 4, 0, 0]} />
            {averages.fylke && <Bar dataKey={snittKey} fill="#3F8A86" radius={[4, 4, 0, 0]} />}
            <Bar dataKey="Landssnitt" fill="#9CA3AF" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <p className="text-xs text-[#8AA4BF] mt-1">Snitta er uvekta gjennomsnitt av kommunane sine andelar ({averages.fylke ? `${averages.fylke.kommune_count} ${gruppeNamn ? "storbyar" : "kommunar i fylket"}, ` : ""}{averages.land.kommune_count} kommunar i landet), {averages.year}.</p>
    </div>
  );
};

export default PendlingAvgChart;
